module.exports = __webpack_public_path__ + "static/media/scds2018.8841b783.jpg";